import { render, staticRenderFns } from "./ButtonLink.component.vue?vue&type=template&id=5ff22de8&"
import script from "./ButtonLink.component.vue?vue&type=script&lang=js&"
export * from "./ButtonLink.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports